import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

export interface WhiteLabelData {
  accountSlug: string;
  whiteLabelData: any;
}

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelService {
  isWhiteLabel = window.location.hostname.split('.').length === 4 || window.location.port === '8101';
  accountSlug: string | null = null;
  whiteLabelData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private apiService: ApiService) {
    if (this.isWhiteLabel) {
      this.accountSlug = window.location.port === '8101' ? 'sponstar-dev' : window.location.hostname.split('.')[0];
      this.apiService.get(`accounts/whitelabel/${this.accountSlug}`).subscribe((res) => {
        this.whiteLabelData.next(res);
      });
    }
  }
}
